import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  transferNo: '',
  applyTimeRange: {
    start: '',
    end: ''
  },
  transferStatus: ''
};
import { cloneDeep } from 'lodash';
export default {
  meta: {
    title: '钱包提现',
    auth: true,
    authorityValue: "store-transfers-manage"
  },
  name: 'wallet',
  data: function data() {
    return {
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'transferList',
        params: cloneDeep(initForm)
      },
      balance: {},
      records: []
    };
  },
  methods: {
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    showTransferStatus: function showTransferStatus(row, e) {
      if (Array.isArray(e)) {
        return e.includes(row.transferStatus);
      } else {
        return row.transferStatus == e;
      }
    },
    getBalance: function getBalance() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.balance();

              case 2:
                data = _context.sent;
                _this.balance = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    download: function download() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$_this2$$api$tr, records, columns, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$api.transferList(_objectSpread(_objectSpread({}, _this2.form), {}, {
                  pageSize: 99999
                }));

              case 2:
                _yield$_this2$$api$tr = _context3.sent;
                records = _yield$_this2$$api$tr.records;
                _this2.records = records;
                columns = [{
                  label: '提现流水号',
                  prop: 'transferNo'
                }, {
                  label: '申请时间',
                  prop: 'applyTime'
                }, {
                  label: '金额（元）',
                  prop: 'transferAmount'
                }, {
                  label: '状态',
                  prop: 'transferStatus'
                }, {
                  label: '原因',
                  prop: 'failureReason'
                }, {
                  label: '审核时间',
                  prop: 'auditTime'
                }, {
                  label: '打款时间',
                  prop: 'transferTime'
                }];
                data = [];
                console.log('1111', _this2.records);

                _this2.records.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(v) {
                    var params, transferStatus;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            params = {};
                            params = _objectSpread({}, v);
                            transferStatus = _this2.dict.walletStatus.filter(function (e) {
                              return e.value == v.transferStatus;
                            });

                            _this2.$set(params, 'transferStatus', transferStatus[0].label);

                            data.push(params);

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                console.log('params', data);

                _this2.xlsxExport(columns, data, '钱包提现记录');

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.getBalance();
  }
};